<template>
  <a class="mx-2" @click="triggerAction">
    <slot>
      <a
        variant="default"
        size="small"
        @click="currentSelectedItemId = resource.id"
      >
        <MTooltip>
          <template v-slot:trigger>
            <MIcon name="eye" />
          </template>
          {{ $tc('action') }}
        </MTooltip>
      </a>
    </slot>
    <FlotoDrawer :open="showDrawer" width="65%" @hide="hideDrawer">
      <template v-slot:title>
        {{ $tc('agent_log_download_requests') }}:
        {{ resource.name }}
      </template>
      <template>
        <MRow class="mb-2" :gutter="0">
          <MCol :size="12" class="m-align-button">
            <MButton
              id="req-log-btn"
              class="mr-2"
              variant="primary"
              @click="requestForLog(resource.id, type)"
            >
              {{ $tc('request') }}
            </MButton>
          </MCol>
        </MRow>
      </template>
      <FlotoCrudContainer
        ref="list"
        as-table
        prepend-new-item
        :columns="tableColumns"
        :fetch-fn="getAgentLogHistory"
      >
        <template v-slot:createdTime="{ item }">
          <td class="text-ellipsis">
            <span v-if="item.createdTime">{{
              item.createdTime | datetime
            }}</span>
            <span v-else>---</span>
          </td>
        </template>
        <template v-slot:updatedTime="{ item }">
          <td class="text-ellipsis">
            <span v-if="item.updatedTime">{{
              item.updatedTime | datetime
            }}</span>
            <span v-else>---</span>
          </td>
        </template>
        <template v-slot:state="{ item }">
          <td class="text-ellipsis">
            <span v-if="item.state">{{ $tc(item.state) }}</span>
            <span v-else>---</span>
          </td>
        </template>
        <template v-slot:actions="{ item, currentOffset }">
          <td>
            <slot name="action" :item="item">
              <MTooltip v-if="item.fileExists === true && currentOffset === 0">
                <template v-slot:trigger>
                  <FlotoDownloadLink
                    :file-name="`${resource.name}_agent_log_${Moment().format(
                      'D-M-YYYY_H-m-s_a'
                    )}.zip`"
                    :url="downloadLog"
                    class="mx-2"
                  >
                    <template v-slot="{ downloading }">
                      <MIcon v-if="!downloading" name="download" />
                    </template>
                  </FlotoDownloadLink>
                </template>
                {{ $t('download') }}
              </MTooltip>
            </slot>
          </td>
        </template>
      </FlotoCrudContainer>
      <template v-slot:actions="{ hide }">
        <MButton variant="default" @click="hide">
          {{ $t('done') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>
<script>
import Moment from 'moment'
import {
  getAgentsLogApi,
  requestLogApi,
} from '../../../api/discovery-agents-api'
import { authComputed } from '@state/modules/auth'

export default {
  name: 'AgentLogRequestDrawer',
  props: {
    resource: { type: Object, required: true },
    type: {
      type: String,
      default() {
        return 'agent'
      },
    },
  },
  data() {
    this.Moment = Moment
    return {
      showDrawer: false,
      tableColumns: [
        {
          name: `${this.$tc('requested')} ${this.$tc('time')}`,
          key: 'createdTime',
        },
        {
          name: `${this.$tc('updated')} ${this.$tc('time')}`,
          key: 'updatedTime',
        },
        {
          name: `${this.$tc('request')} ${this.$tc('status')}`,
          key: 'state',
        },
        {
          name: `${this.$tc('action')}`,
          key: 'actions',
          minWidth: '200px',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
    downloadLog() {
      if (this.accessToken && this.type === 'agent') {
        return `/agent/log/download/${this.resource.id}`
      } else if (this.accessToken && this.type === 'rdp_agent') {
        return `/rdpagent/log/download/${this.resource.id}`
      } else {
        return undefined
      }
    },
  },
  methods: {
    triggerAction() {
      this.$emit('trigger')
      setTimeout(() => {
        this.showDrawer = true
      }, 400)
    },
    hideDrawer() {
      this.showDrawer = false
    },
    refresh() {
      this.$refs.list.refresh()
    },
    getAgentLogHistory(limit, offset) {
      return getAgentsLogApi(this.type, this.resource.id, limit, offset)
    },
    requestForLog(id, type) {
      requestLogApi(id, type).then(() => {
        this.refresh()
      })
    },
  },
}
</script>
